<style scoped>
    div {
        border-radius: 3px;
    }
</style>

<template>
    <div class="flex aic pl15 pr15 pt15 pb15 bg_fff">
        <b class="fs18 flex0 mr10">{{title}}</b>
        <span class="flex1 fs12 color_666">{{content}}</span>
        <slot name="right"></slot>
    </div>
</template>

<script>
    export default {
        name: "tj-title-bar",
        props: {
            title: {
                type: String,
                default: ""
            },
            content: {
                type: String,
                default: ""
            },
        },
    }
</script>
